import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AppComponent } from './app.component';
import { SideBarComponent } from './side-bar/side-bar.component';
import { CommonModule, JsonPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import {MatNativeDateModule} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialExampleModule} from '../material.module';
import { GalleryComponent } from './gallery/gallery.component';
import { PlayerHistoryComponent } from './player-history/player-history.component';
import { RankingsComponent } from './rankings/rankings.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { StandardDialogComponent } from './standard-dialog/standard-dialog.component';
import { APIService } from './api.service';
import { DataService } from './data.service';
import { FunctionService } from './function.service';
import { AlertComponent } from './alert/alert.component';
import { ModalWindowComponent } from './modal/Modal-Window.component';
import { myFilterPipe } from './myFilter.pipe';
import { DatabaseComponent } from './database/database.component';
import { CookieService } from 'ngx-cookie-service';
import { TornsComponent } from './torns/torns.component';
import { DrawsComponent } from './draws/draws.component';
import { MatInputModule } from '@angular/material/input';
import { ScoreEditComponent } from './score-edit/score-edit.component';
import { RulzComponent } from './rulz/rulz.component';
import { ChartComponent } from './chart/chart.component';
//import { NgxChartsModule } from '@swimlane/ngx-charts';
//import { NgbDatepickerModule, } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, Routes } from '@angular/router';
import { PhotosComponent } from './photos/photos.component';
import { LinksComponent } from './links/links.component';
import { DrawComponent } from "./draw/draw.component";

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'tournaments', component: TornsComponent },
  { path: 'rankings', component: RankingsComponent },
  { path: 'gallery', component: GalleryComponent },
  { path: 'photos', component: PhotosComponent },
  { path: 'rules', component: RulzComponent },
  { path: 'links', component: LinksComponent }, // if exists
  { path: 'login', component: LoginComponent },
  { path: 'player-history', component: PlayerHistoryComponent },
];

@NgModule({ 
    declarations: [
        AppComponent,
        SideBarComponent,
        GalleryComponent,
        PlayerHistoryComponent,
        RankingsComponent,
        LoginComponent,
        HomeComponent,
        StandardDialogComponent,
        AlertComponent,
        ModalWindowComponent,
        myFilterPipe,
        DatabaseComponent,
        TornsComponent,
        DrawsComponent,
        ScoreEditComponent,
        RulzComponent,
        ChartComponent,
        PhotosComponent,
        DrawComponent
    ],
    bootstrap: [AppComponent],
    //schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    BrowserAnimationsModule,
    MaterialExampleModule,
    FormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    CommonModule
], providers: [APIService, DataService, FunctionService, CookieService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
